export default [
  {
    "display": "(UTC-12:00) International Date Line West",
    "id": "Dateline Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": -12
  },
  {
    "display": "(UTC-11:00) Coordinated Universal Time-11",
    "id": "UTC-11",
    "supportDaylightSavings": false,
    "utc_Offset": -11
  },
  {
    "display": "(UTC-10:00) Aleutian Islands",
    "id": "Aleutian Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -10
  },
  {
    "display": "(UTC-10:00) Hawaii",
    "id": "Hawaiian Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": -10
  },
  {
    "display": "(UTC-09:30) Marquesas Islands",
    "id": "Marquesas Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": -9
  },
  {
    "display": "(UTC-09:00) Alaska",
    "id": "Alaskan Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -9
  },
  {
    "display": "(UTC-09:00) Coordinated Universal Time-09",
    "id": "UTC-09",
    "supportDaylightSavings": false,
    "utc_Offset": -9
  },
  {
    "display": "(UTC-08:00) Baja California",
    "id": "Pacific Standard Time (Mexico)",
    "supportDaylightSavings": true,
    "utc_Offset": -8
  },
  {
    "display": "(UTC-08:00) Coordinated Universal Time-08",
    "id": "UTC-08",
    "supportDaylightSavings": false,
    "utc_Offset": -8
  },
  {
    "display": "(UTC-08:00) Pacific Time (US & Canada)",
    "id": "Pacific Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -8
  },
  {
    "display": "(UTC-07:00) Arizona",
    "id": "US Mountain Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": -7
  },
  {
    "display": "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
    "id": "Mountain Standard Time (Mexico)",
    "supportDaylightSavings": true,
    "utc_Offset": -7
  },
  {
    "display": "(UTC-07:00) Mountain Time (US & Canada)",
    "id": "Mountain Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -7
  },
  {
    "display": "(UTC-06:00) Central America",
    "id": "Central America Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": -6
  },
  {
    "display": "(UTC-06:00) Central Time (US & Canada)",
    "id": "Central Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -6
  },
  {
    "display": "(UTC-06:00) Easter Island",
    "id": "Easter Island Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -6
  },
  {
    "display": "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
    "id": "Central Standard Time (Mexico)",
    "supportDaylightSavings": true,
    "utc_Offset": -6
  },
  {
    "display": "(UTC-06:00) Saskatchewan",
    "id": "Canada Central Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": -6
  },
  {
    "display": "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
    "id": "SA Pacific Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": -5
  },
  {
    "display": "(UTC-05:00) Chetumal",
    "id": "Eastern Standard Time (Mexico)",
    "supportDaylightSavings": true,
    "utc_Offset": -5
  },
  {
    "display": "(UTC-05:00) Eastern Time (US & Canada)",
    "id": "Eastern Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -5
  },
  {
    "display": "(UTC-05:00) Haiti",
    "id": "Haiti Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -5
  },
  {
    "display": "(UTC-05:00) Havana",
    "id": "Cuba Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -5
  },
  {
    "display": "(UTC-05:00) Indiana (East)",
    "id": "US Eastern Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -5
  },
  {
    "display": "(UTC-05:00) Turks and Caicos",
    "id": "Turks And Caicos Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -5
  },
  {
    "display": "(UTC-04:00) Asuncion",
    "id": "Paraguay Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -4
  },
  {
    "display": "(UTC-04:00) Atlantic Time (Canada)",
    "id": "Atlantic Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -4
  },
  {
    "display": "(UTC-04:00) Caracas",
    "id": "Venezuela Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -4
  },
  {
    "display": "(UTC-04:00) Cuiaba",
    "id": "Central Brazilian Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -4
  },
  {
    "display": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
    "id": "SA Western Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": -4
  },
  {
    "display": "(UTC-04:00) Santiago",
    "id": "Pacific SA Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -4
  },
  {
    "display": "(UTC-03:30) Newfoundland",
    "id": "Newfoundland Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -3
  },
  {
    "display": "(UTC-03:00) Araguaina",
    "id": "Tocantins Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -3
  },
  {
    "display": "(UTC-03:00) Brasilia",
    "id": "E. South America Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -3
  },
  {
    "display": "(UTC-03:00) Cayenne, Fortaleza",
    "id": "SA Eastern Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": -3
  },
  {
    "display": "(UTC-03:00) City of Buenos Aires",
    "id": "Argentina Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -3
  },
  {
    "display": "(UTC-03:00) Greenland",
    "id": "Greenland Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -3
  },
  {
    "display": "(UTC-03:00) Montevideo",
    "id": "Montevideo Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -3
  },
  {
    "display": "(UTC-03:00) Punta Arenas",
    "id": "Magallanes Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -3
  },
  {
    "display": "(UTC-03:00) Saint Pierre and Miquelon",
    "id": "Saint Pierre Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -3
  },
  {
    "display": "(UTC-03:00) Salvador",
    "id": "Bahia Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -3
  },
  {
    "display": "(UTC-02:00) Coordinated Universal Time-02",
    "id": "UTC-02",
    "supportDaylightSavings": false,
    "utc_Offset": -2
  },
  {
    "display": "(UTC-02:00) Mid-Atlantic - Old",
    "id": "Mid-Atlantic Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -2
  },
  {
    "display": "(UTC-01:00) Azores",
    "id": "Azores Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": -1
  },
  {
    "display": "(UTC-01:00) Cabo Verde Is.",
    "id": "Cape Verde Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": -1
  },
  {
    "display": "(UTC) Coordinated Universal Time",
    "id": "UTC",
    "supportDaylightSavings": false,
    "utc_Offset": 0
  },
  {
    "display": "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
    "id": "GMT Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 0
  },
  {
    "display": "(UTC+00:00) Monrovia, Reykjavik",
    "id": "Greenwich Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 0
  },
  {
    "display": "(UTC+00:00) Sao Tome",
    "id": "Sao Tome Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 0
  },
  {
    "display": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
    "id": "W. Europe Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 1
  },
  {
    "display": "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
    "id": "Central Europe Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 1
  },
  {
    "display": "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
    "id": "Romance Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 1
  },
  {
    "display": "(UTC+01:00) Casablanca",
    "id": "Morocco Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 1
  },
  {
    "display": "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
    "id": "Central European Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 1
  },
  {
    "display": "(UTC+01:00) West Central Africa",
    "id": "W. Central Africa Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 1
  },
  {
    "display": "(UTC+02:00) Amman",
    "id": "Jordan Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 2
  },
  {
    "display": "(UTC+02:00) Athens, Bucharest",
    "id": "GTB Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 2
  },
  {
    "display": "(UTC+02:00) Beirut",
    "id": "Middle East Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 2
  },
  {
    "display": "(UTC+02:00) Cairo",
    "id": "Egypt Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 2
  },
  {
    "display": "(UTC+02:00) Chisinau",
    "id": "E. Europe Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 2
  },
  {
    "display": "(UTC+02:00) Damascus",
    "id": "Syria Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 2
  },
  {
    "display": "(UTC+02:00) Gaza, Hebron",
    "id": "West Bank Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 2
  },
  {
    "display": "(UTC+02:00) Harare, Pretoria",
    "id": "South Africa Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 2
  },
  {
    "display": "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
    "id": "FLE Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 2
  },
  {
    "display": "(UTC+02:00) Jerusalem",
    "id": "Israel Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 2
  },
  {
    "display": "(UTC+02:00) Kaliningrad",
    "id": "Kaliningrad Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 2
  },
  {
    "display": "(UTC+02:00) Khartoum",
    "id": "Sudan Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 2
  },
  {
    "display": "(UTC+02:00) Tripoli",
    "id": "Libya Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 2
  },
  {
    "display": "(UTC+02:00) Windhoek",
    "id": "Namibia Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 2
  },
  {
    "display": "(UTC+03:00) Baghdad",
    "id": "Arabic Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 3
  },
  {
    "display": "(UTC+03:00) Istanbul",
    "id": "Turkey Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 3
  },
  {
    "display": "(UTC+03:00) Kuwait, Riyadh",
    "id": "Arab Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 3
  },
  {
    "display": "(UTC+03:00) Minsk",
    "id": "Belarus Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 3
  },
  {
    "display": "(UTC+03:00) Moscow, St. Petersburg",
    "id": "Russian Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 3
  },
  {
    "display": "(UTC+03:00) Nairobi",
    "id": "E. Africa Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 3
  },
  {
    "display": "(UTC+03:30) Tehran",
    "id": "Iran Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 3
  },
  {
    "display": "(UTC+04:00) Abu Dhabi, Muscat",
    "id": "Arabian Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 4
  },
  {
    "display": "(UTC+04:00) Astrakhan, Ulyanovsk",
    "id": "Astrakhan Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 4
  },
  {
    "display": "(UTC+04:00) Baku",
    "id": "Azerbaijan Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 4
  },
  {
    "display": "(UTC+04:00) Izhevsk, Samara",
    "id": "Russia Time Zone 3",
    "supportDaylightSavings": true,
    "utc_Offset": 4
  },
  {
    "display": "(UTC+04:00) Port Louis",
    "id": "Mauritius Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 4
  },
  {
    "display": "(UTC+04:00) Saratov",
    "id": "Saratov Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 4
  },
  {
    "display": "(UTC+04:00) Tbilisi",
    "id": "Georgian Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 4
  },
  {
    "display": "(UTC+04:00) Volgograd",
    "id": "Volgograd Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 4
  },
  {
    "display": "(UTC+04:00) Yerevan",
    "id": "Caucasus Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 4
  },
  {
    "display": "(UTC+04:30) Kabul",
    "id": "Afghanistan Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 4
  },
  {
    "display": "(UTC+05:00) Ashgabat, Tashkent",
    "id": "West Asia Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 5
  },
  {
    "display": "(UTC+05:00) Ekaterinburg",
    "id": "Ekaterinburg Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 5
  },
  {
    "display": "(UTC+05:00) Islamabad, Karachi",
    "id": "Pakistan Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 5
  },
  {
    "display": "(UTC+05:00) Qyzylorda",
    "id": "Qyzylorda Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 5
  },
  {
    "display": "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
    "id": "India Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 5
  },
  {
    "display": "(UTC+05:30) Sri Jayawardenepura",
    "id": "Sri Lanka Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 5
  },
  {
    "display": "(UTC+05:45) Kathmandu",
    "id": "Nepal Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 5
  },
  {
    "display": "(UTC+06:00) Astana",
    "id": "Central Asia Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 6
  },
  {
    "display": "(UTC+06:00) Dhaka",
    "id": "Bangladesh Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 6
  },
  {
    "display": "(UTC+06:00) Omsk",
    "id": "Omsk Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 6
  },
  {
    "display": "(UTC+06:30) Yangon (Rangoon)",
    "id": "Myanmar Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 6
  },
  {
    "display": "(UTC+07:00) Bangkok, Hanoi, Jakarta",
    "id": "SE Asia Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 7
  },
  {
    "display": "(UTC+07:00) Barnaul, Gorno-Altaysk",
    "id": "Altai Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 7
  },
  {
    "display": "(UTC+07:00) Hovd",
    "id": "W. Mongolia Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 7
  },
  {
    "display": "(UTC+07:00) Krasnoyarsk",
    "id": "North Asia Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 7
  },
  {
    "display": "(UTC+07:00) Novosibirsk",
    "id": "N. Central Asia Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 7
  },
  {
    "display": "(UTC+07:00) Tomsk",
    "id": "Tomsk Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 7
  },
  {
    "display": "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
    "id": "China Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 8
  },
  {
    "display": "(UTC+08:00) Irkutsk",
    "id": "North Asia East Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 8
  },
  {
    "display": "(UTC+08:00) Kuala Lumpur, Singapore",
    "id": "Singapore Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 8
  },
  {
    "display": "(UTC+08:00) Perth",
    "id": "W. Australia Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 8
  },
  {
    "display": "(UTC+08:00) Taipei",
    "id": "Taipei Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 8
  },
  {
    "display": "(UTC+08:00) Ulaanbaatar",
    "id": "Ulaanbaatar Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 8
  },
  {
    "display": "(UTC+08:45) Eucla",
    "id": "Aus Central W. Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 8
  },
  {
    "display": "(UTC+09:00) Chita",
    "id": "Transbaikal Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 9
  },
  {
    "display": "(UTC+09:00) Osaka, Sapporo, Tokyo",
    "id": "Tokyo Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 9
  },
  {
    "display": "(UTC+09:00) Pyongyang",
    "id": "North Korea Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 9
  },
  {
    "display": "(UTC+09:00) Seoul",
    "id": "Korea Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 9
  },
  {
    "display": "(UTC+09:00) Yakutsk",
    "id": "Yakutsk Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 9
  },
  {
    "display": "(UTC+09:30) Adelaide",
    "id": "Cen. Australia Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 9
  },
  {
    "display": "(UTC+09:30) Darwin",
    "id": "AUS Central Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 9
  },
  {
    "display": "(UTC+10:00) Brisbane",
    "id": "E. Australia Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 10
  },
  {
    "display": "(UTC+10:00) Canberra, Melbourne, Sydney",
    "id": "AUS Eastern Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 10
  },
  {
    "display": "(UTC+10:00) Guam, Port Moresby",
    "id": "West Pacific Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 10
  },
  {
    "display": "(UTC+10:00) Hobart",
    "id": "Tasmania Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 10
  },
  {
    "display": "(UTC+10:00) Vladivostok",
    "id": "Vladivostok Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 10
  },
  {
    "display": "(UTC+10:30) Lord Howe Island",
    "id": "Lord Howe Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 10
  },
  {
    "display": "(UTC+11:00) Bougainville Island",
    "id": "Bougainville Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 11
  },
  {
    "display": "(UTC+11:00) Chokurdakh",
    "id": "Russia Time Zone 10",
    "supportDaylightSavings": true,
    "utc_Offset": 11
  },
  {
    "display": "(UTC+11:00) Magadan",
    "id": "Magadan Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 11
  },
  {
    "display": "(UTC+11:00) Norfolk Island",
    "id": "Norfolk Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 11
  },
  {
    "display": "(UTC+11:00) Sakhalin",
    "id": "Sakhalin Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 11
  },
  {
    "display": "(UTC+11:00) Solomon Is., New Caledonia",
    "id": "Central Pacific Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 11
  },
  {
    "display": "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky",
    "id": "Russia Time Zone 11",
    "supportDaylightSavings": true,
    "utc_Offset": 12
  },
  {
    "display": "(UTC+12:00) Auckland, Wellington",
    "id": "New Zealand Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 12
  },
  {
    "display": "(UTC+12:00) Coordinated Universal Time+12",
    "id": "UTC+12",
    "supportDaylightSavings": false,
    "utc_Offset": 12
  },
  {
    "display": "(UTC+12:00) Fiji",
    "id": "Fiji Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 12
  },
  {
    "display": "(UTC+12:00) Petropavlovsk-Kamchatsky - Old",
    "id": "Kamchatka Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 12
  },
  {
    "display": "(UTC+12:45) Chatham Islands",
    "id": "Chatham Islands Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 12
  },
  {
    "display": "(UTC+13:00) Coordinated Universal Time+13",
    "id": "UTC+13",
    "supportDaylightSavings": false,
    "utc_Offset": 13
  },
  {
    "display": "(UTC+13:00) Nuku'alofa",
    "id": "Tonga Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 13
  },
  {
    "display": "(UTC+13:00) Samoa",
    "id": "Samoa Standard Time",
    "supportDaylightSavings": true,
    "utc_Offset": 13
  },
  {
    "display": "(UTC+14:00) Kiritimati Island",
    "id": "Line Islands Standard Time",
    "supportDaylightSavings": false,
    "utc_Offset": 14
  }
]
